import { STEP } from '../@types/state'
import { ProgressType } from '../@types/progress'
import { WizardFlowType } from '../@types/wizardFlowType'

const defaultProgressMap: ProgressType = {
  [STEP.LOCATION]: { previous: 10, current: 23, next: 39 },
  [STEP.COMMERCIAL_REAL_ESTATE_TYPE]: { previous: 23, current: 36, next: 49 },
  [STEP.AREA]: { previous: 36, current: 49, next: 62 },
  [STEP.INTENT]: { previous: 49, current: 62, next: 75 },
  [STEP.EMPLOYMENT]: { previous: 62, current: 75, next: 88 },
  [STEP.TIME_HORIZON]: { previous: 75, current: 88, next: 100 },
  [STEP.OWNER]: { previous: 88, current: 91, next: 100 },
  [STEP.CONTACT]: { previous: 91, current: 100, next: 100 },
}

const progressMap: { [k in WizardFlowType]: ProgressType } = {
  [WizardFlowType.RLE]: defaultProgressMap,
  [WizardFlowType.IBW]: defaultProgressMap,
  [WizardFlowType.SOLAR]: {
    // TODO add missing mapping here
  },
}

export { progressMap }
